export const preparePax = (pax) => {
    for (let i = 0; i < pax.length; i++) {
        pax[i].roomNum = (i + 1);
    }
    return [...pax];
};

export const mapLocale = (locale = '') => {
    switch (locale.toLowerCase()) {
        case 'heb':
            return 'he-il';
        case 'eng':
            return 'en-us';
        default:
            return 'en-us';
    }
}

export const isMobileDevice = () => {
    // TODO : CHECK IF MOBILE RESULOTION ! 
    if (window.innerWidth < 767)
        return true;
    else
        return false;
}

export const searchParams = (data) => Object.keys(data).map((key) => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
}).join('&');


export const getParams = query => {
    if (!query) {
        return {};
    }

    return (/^[?#]/.test(query) ? query.slice(1) : query)
        .split('&')
        .reduce((params, param) => {
            let [key, value] = param.split('=');
            params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
            return params;
        }, {});
};


// WEBPACK FOOTER //
// ./src/components/common/utils.js